module.exports = __webpack_public_path__ + "img/speedtest.096a822e.png";